/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router";

import Header from "@/layout/Header";
import Nav from "@/layout/Nav";
import Footer from "@/layout/Footer";

const Layout = ({ children }) => {
    const [alertModal, setAlertModal] = useState(false);

    return (
        <>
            <Header setAlertModal={setAlertModal} />

            <main>
                <Nav />
                <div className="app-content">
                    <Outlet />
                </div>
            </main>
            <Footer />
        </>
    );
};

export default Layout;
